"use strict";
//small file that is loaded on most of the pages on the dashboard

(function() {

  $(document).ready(function() {
    //active (selected) navigation elements
    $('.nav [href="' + window.location.pathname + '"]').closest('li').toggleClass('active');

    //register global ajax handlers
    $(document).ajaxStart(function() { $('.ajax-spinner').show(); });
    $(document).ajaxStop(function() { $('.ajax-spinner').hide(); });

    //ajax spinner follows mouse
    $(document).bind('mousemove', function(mouseEvent) {
      $('.ajax-spinner').css({
        left: mouseEvent.pageX + 15,
        top: mouseEvent.pageY
      });
    });
  });
}());